"use strict";
//@ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.escapeQuery = escapeQuery;
exports.transformInstruction = transformInstruction;
exports.joinInstructions = joinInstructions;
function escapeQuery(val) {
    // ESLINT - Regex Complains about Escaping Characters - Using For Bots trying SQL Queries
    return String(val || '').replace(/([\(\)\[\]\/\'\"])/g, '\\$1');
}
function transformInstruction(instruction) {
    const { operator, field, operands = [] } = instruction;
    switch (operator) {
        case 'OR':
            return (operands || [])
                .filter(Boolean)
                .map((operand) => `${field}:"${escapeQuery(operand)}"`)
                .join(' OR ');
        case 'AND':
            return (operands || [])
                .filter(Boolean)
                .map((operand) => `${field}:"${escapeQuery(operand)}"`)
                .join(' AND ');
        case 'TO': {
            if ((operands || []).length !== 2) {
                throw new Error('TO operator accepts exactly 2 operands');
            }
            return `${field}:${operands[0]} TO ${operands[1]}`;
        }
        default:
            throw new Error(`Unsupported operator, ${operator}`);
    }
}
// Generate a filter query based on Algolia spec
// https://www.algolia.com/doc/api-reference/api-parameters/filters/
function joinInstructions(instructionSet, glue = 'AND') {
    return instructionSet
        .map(transformInstruction)
        .filter(Boolean)
        .map((instruction) => `(${instruction})`) // Wrap and Join -> (category:"Painting") AND (subject:"Men")
        .join(` ${glue} `);
}
